import * as React from 'react';
import { Component } from 'react';
import styles from '../../styles/flyouts/room_types/Properties.scss';
import * as _ from 'lodash';
import { withRouter } from 'react-router';
import autobind from 'autobind-decorator';
import { __, validateForm } from '../../core/utils';
import { setNotification } from '../../redux/actions/general/notification';
import {
  listRoomTypes,
  updateRoomType,
} from '../../redux/actions/table/room_types';
import EditRoomTypeForm from '../../forms/room_types/EditRoomTypeForm';

@withRouter
class Properties extends Component {
  @autobind
  _handleSubmit(formData) {
    return validateForm(
      updateRoomType(formData.id, _.omit(formData, ['id'])).then(() => {
        listRoomTypes(this.props.match.params.stage);

        this.props.readAction(formData.id);

        setNotification(__('room-types.flyout.notification.saved'));
      })
    );
  }

  render() {
    const { data } = this.props;

    return (
      <div className={styles.scroller}>
        <EditRoomTypeForm
          onSubmit={this._handleSubmit}
          data={data}
          initialValues={{
            ..._.pick(data, [
              'id',
              'code',
              'title',
              'description',
              'requirement',
            ]),
          }}
        />
      </div>
    );
  }
}

export default Properties;
